import Link from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { assetUrl } from 'utils/url'

type PemantauanPelaksanaanPegawaiCardProps = {
  targetPath: string
  pegawaiLabel: string
}

export const PemantauanPelaksanaanPegawaiCard = ({
  targetPath,
  pegawaiLabel,
}: PemantauanPelaksanaanPegawaiCardProps) => {
  return (
    <section className="p-6 bg-white rounded-lg shadow-card">
      <div className="flex items-center justify-between gap-6 ">
        <div className="flex items-center gap-6">
          <img
            alt=""
            src={assetUrl('/illustrations/img-book-rapor-graphic.png')}
            width={84}
            height={84}
            className="flex-shrink-0"
          />
          <div>
            <Text variant="heading-lg" as="h2" className="mb-1">
              Pemantauan Kinerja dan Rekomendasi Predikat Kinerja
            </Text>
            <Text color="subdued">
              Lakukan untuk seluruh {pegawaiLabel} di wilayah binaan Anda.
            </Text>
          </div>
        </div>
        <Link href={targetPath} passHref>
          <Button
            size="lg"
            as="a"
            type={undefined}
            color="black"
            className="min-w-60 whitespace-nowrap"
          >
            Lakukan
          </Button>
        </Link>
      </div>
    </section>
  )
}
